/**
 * URL-safety helpers shared across the app.
 *
 * The only schemes that should ever become a live, clickable navigation
 * target are http/https. Anything else (`javascript:`, `data:`, `file:`,
 * `vbscript:`, …) can turn attacker-influenced content into click-triggered
 * XSS, so it must be rendered as inert text instead of an `<a href>`.
 *
 * `online_search` results flow into the workspace from a public, untrusted
 * web crawl and reach the report-library `/events/v2` endpoint, so their
 * URLs are guarded with `isSafeUrl` before any anchor is rendered.
 */

/**
 * True only when `url` is an absolute http/https URL.
 *
 * Used for online-support / online-reference links, which are always
 * absolute web URLs — there is no legitimate relative, mailto, or other
 * scheme to allow here, so the allowlist is intentionally just http/https.
 */
export function isSafeUrl(url: string | undefined | null): boolean {
  if (!url) return false;
  const trimmed = url.trim().toLowerCase();
  return trimmed.startsWith('http:') || trimmed.startsWith('https:');
}
